import store from './store'
import { userService } from './userService'

/**
 * The user module façade. `store` is scaffolding — the domain has no shared state of its own yet —
 * so in practice callers want `user.service`.
 */
export const useUser = () => {
  return {
    user: {
      store,
      service: userService()
    }
  }
}
